<template>
	<page-content-layout class="quotes" title="Ordrer">
		<button-view v-show="checked.length > 0" slot="tools" label="Overfør til økonomi system" @click="sendToSys" />
		<button-view v-if="false" v-show="checked.length > 0" slot="tools" label="Maker som overført" @click="markAsSent" />
		<button-group-view slot="tools" v-if="false" :actions="[
			{
				label: 'Alle',
				value: 'all'
			},
			{
				label: 'Åben',
				value: 'open'
			},
			{
				label: 'Udført',
				value: 'completed'
			},
			{
				label: 'Afventer',
				value: 'pending'
			},
			{
				label: 'Godkendt',
				value: 'approved'
			},
			{
				label: 'Faktureret',
				value: 'invoiced'
			}
		]" v-model="filter" />
		<button-group-view slot="tools" :actions="[
			{
				label: 'Alle',
				value: 'all'
			},
			{
				label: 'Afventer godkendelse',
				value: 'pending'
			},
			{
				label: 'Klar til fakturering',
				value: 'ready'
			}
		]" v-model="kind" />
		<button-view slot="tools" label="Opret" @click="open(null)" />
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" :status="_monthStatus" @browse="updateMonthStatus" />
			<div class="tasks"></div>
			<new-table-view v-model="checked" class="list" @itemClick="itemClick" :columns="[
				{
					label: 'Status',
					name: ['status'],
					translation: _status,
					template: {
						name: 'status',
						params: {
							color: {
								name: ['status'],
								translation: _statusColors
							},
							description: {
								name: ['status'],
								translation: _statusDesc
							}
						}
					}
				},
				{
					label: 'Nr',
					name: 'num',
					filter: 'integer'
					//filter: 'float',
					//align: 'right'
				},
				{
					label: 'Udført',
					name: 'due',
					filter: 'timestamp'
					//filter: 'float',
					//align: 'right'
				},
				/*{
					label: 'E-mail',
					data: '-',
					//filter: 'float',
					//align: 'right'
				},
				{
					label: 'Kontakt',
					data: '-',
					//filter: 'float',
					//align: 'right'
				},*/
				{
					label: 'E-mail',
					name: 'email_sent',
					default: 'Ikke sendt',
					filter: 'days'
					//filter: 'float',
					//align: 'right'
				},
				{
					label: 'Navn',
					name: ['customer', 'name']
				},
				/*{
					label: 'Kunde',
					name: ['_embedded', 'contact', 'name'],
					//filter: 'float',
					//align: 'right'
				},*/
				{
					label: 'Ansvarlig',
					name: ['_embedded', 'employee', 'name'],
					//filter: 'float',
					//align: 'right'
				},
				{
					label: 'Kostpris',
					name: ['cost'],
					filter: 'number'
				},
				{
					label: 'Salgspris',
					name: ['total'],
					filter: 'number'
				},
				{
					label: 'Dæk.bidrag',
					name: ['margin'],
					filter: 'number'
				},
				{
					label: 'Dæk.grad',
					name: ['margin_coeff'],
					filter: 'number'
				},
				{
					label: '',
					name: 'context',
					align: 'right',
					template: {
						name: 'button',
						label: '...'
					}
				}			
			]" :items="items" @context="itemContext" />
		</div>
	</page-content-layout>
</template>

<script>
	import EmailWindow from '../windows/EmailWindow'
	import LeadModel from '../model/Lead'
	import LeadWindow from '../windows/LeadWindow'
	import QuoteModel from '../model/Order'
	import QuoteWindow from '../windows/OrderWindow'
	import InvoiceWindow from '../windows/InvoiceWindow'
	import NewTableView from '../views/NewTableView'
	import merge from '../functions/merge'
	import ContextPopupView from '../views/ContextPopupView'
	import DatePickerStdView from '../views/DatePickerStdView'

	import { bus } from '../../bus'

    export default {
		components: {
			NewTableView,
			DatePickerStdView
		},
		data() {
			return {
				filter: 'all',
				items: [],
				colors: [],
				status: [],
				date: (new Date()).format('Y-m-d'),
				monthStatus: {},
				ownership: 'all',
				checked: [],
				kind: 'all'
			};
		},
		computed: {
			_monthStatus() {
				var r = [];

				var src = this.ownership == 'mine' ? this.monthStatus.mine : this.monthStatus.all;

				

				for (var date in src) {
					var s = src[date];

					r.push({
						date: date,
						color: s.red > 0 ? 'red' : (s.yellow > 0 ? 'yellow' : 'green'),
						label: ''
					});
				}

				

				return r;
			},
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].label;
				}

				return r;
			},
			_statusColors() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this._colors[this.status[i].color];
				}

				return r;
			},
			_statusDesc() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].desc;
				}

				return r;
			},
			_colors() {
				var r = [];

				for (var i = 0; i < this.colors.length; ++i) {
					r[this.colors[i].name] = this.colors[i].color;
				}

				return r;
			}
		},
		watch: {
			date(n, o) {
				this.update();
			},
			kind() {
				this.update();
			}
		},
		methods: {
			sendToSys() {
				

				setTimeout(function () {
					alert('Kunne ikke forbinde til økonomi system');
				}, 1000);
			},
			markAsSent() {
				
			},
			async itemClick(item) {
				this.open(item.id);
			},
			itemContext(item, event) {
				event.stopPropagation();

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: [
						{
							label: 'Opret kopi',
							action: async function () {
								var ent 	= await QuoteModel.read(self.axios, item.id);
								ent.id 		= null;
								ent.created = null;

								self.$store.state.windowStack.push(QuoteWindow, {
									value: ent, 
									submit: async function (entity) {
										if (await QuoteModel.save(self.axios, entity)) {
											self.$store.state.windowStack.pop();
											bus.$emit('update');
										}
									}
								});
							}
						},
						null,
						{
							label: 'Udskriv',
							action: async function () {
								window.open(process.env.VUE_APP_API + 'sales/orders/' + item.id + '/print/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'E-mail',
							action: async function () {	
								var entity = await QuoteModel.read(self.axios, item.id);
								var settings = (await self.axios.get('/us/settings/')).data;

								if (entity.email_recipient === null) {
									entity.email_recipient = entity.customer.email;
								}

								if (entity.email_message === null) {
									entity.email_message = settings.email.orderDefault;
								}

								entity.sender_employee_id 			= self.$store.state.employee.id;
								entity._embedded.sender_employee	= self.$store.state.employee;

								self.$store.state.windowStack.push(EmailWindow, {
									entity: entity, 
									submit: async function (entity) {
										entity.sender_employee_id = entity.sender_employee_id;

										self.axios
											.post('/sales/orders/' + entity.id + '/email/', entity)
											.then(function (r) {
												self.$store.state.windowStack.pop();
												bus.$emit('update');
											}, function () {
												alert('Kunne ikke sende, er emailen korrekt?');
											});
									}
								});
							}
						},
						{
							label: 'Gensend',
							enabled: item.email_sent !== null && item.email_sent !== undefined,
							action: async function () {
								await self.axios.post('/sales/orders/' + item.id + '/resend/');
							}
						},
						null,
						{
							label: 'Slet',
							action: async function () {
								if (await QuoteModel.delete(self.axios, item.id)) {
									bus.$emit('update');
								}
							}
						}
					]
				});
			},
			async open(id) {
				var self = this;
				var order = {};
				
				var ent = id ? await QuoteModel.read(self.axios, id) : QuoteModel.entity();

				if (!id) {
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
				}

				this.$store.state.windowStack.push(QuoteWindow, {
					value: ent, 
					submit: async function (entity, invoice = false, paid = false) {
						if ((order = await QuoteModel.save(self.axios, entity, invoice, paid))) {
							self.$store.state.windowStack.pop();
							self.update();
						}
					}
				});
			},
			async updateMonthStatus(year, month) {
				this.monthStatus = (await this.axios.get('/sales/orders/status/' + year + '/' + month + '/' + this.filter + '/')).data;
			},
			async update() {
				var self = this;

				self.items = null;

				// Select correct filter
				var d = new Date(this.date);

				if (this.kind == 'all') {
					this.items = (await this.axios.get('/sales/orders/' + d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + '/')).data._items;
				} else {
					this.axios.get('/sales/orders/processable/?kind=' + this.kind).then(function () {
						var status = self.filter;

						return function (r) {
							if (status == self.filter) {
								self.items = r.data._items;
							}
						}
					}());
				}

				this.updateMonthStatus((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1);
			}
		},
		mounted() {
			this.axios.put('/activity/orders/');

			this.update();

			var self = this;

			this.axios
				.get('/sales/orders/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/config/status/colors/')
				.then(function (r) {
					self.colors = r.data._items;
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		grid-column: 2 / 3;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}
</style>